import React, { useEffect, useState } from 'react';
import '../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery } from '@mui/material';


const AdminSaleView = () => {
    const [formData, setFormData] = useState([]);
    const isDesktop = useMediaQuery('(min-width:768px)');
    useEffect(() => {
        // Retrieve the URL parameters
        const query = new URLSearchParams(window.location.search);
        const formParam = query.get('form');

        if (formParam) {
            try {
                // Parse the form data
                const parsedForm = JSON.parse(decodeURIComponent(formParam));
                setFormData(parsedForm);
            } catch (error) {
                console.error('Error parsing form data:', error);
            }
        }
    }, []);

    // console.log(formData)
    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };




    return (
        <>
            <div style={{ margin: '1% 0%', width: '100%' }}>

                <h3 className='centered-heading'>Admin Sale Entry View</h3>
                <div className="dashed-line"></div>
                <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                    <Table style={isDesktop ? { width: '70%' } : { width: '100%' }}>
                        <TableBody>

                            <TableRow>

                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Size</TableCell>

                                {formData?.info?.map((item, index) => (
                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{item.size}</TableCell>
                                ))}

                            </TableRow>


                            <TableRow>

                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Color</TableCell>

                                {formData?.info?.map((item, index) => (

                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{item.color}</TableCell>
                                ))}

                            </TableRow>

                            <TableRow>

                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Sale Price</TableCell>

                                {formData?.info?.map((item, index) => (

                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{item.srate}</TableCell>
                                ))}

                            </TableRow>

                            {/* <TableRow>

                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Purchase Price</TableCell>

                                {formData?.info?.map((item, index) => (

                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{item.prate}</TableCell>
                                ))}

                            </TableRow> */}
                            <TableRow>

                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Stock Qty</TableCell>

                                {formData?.info?.map((item, index) => (

                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{item.bqty}</TableCell>
                                ))}

                            </TableRow>
                            <TableRow>

                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Issued Qty</TableCell>

                                {formData?.info?.map((item, index) => (

                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{item.issqty}</TableCell>
                                ))}

                            </TableRow>


                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </>
    );
};

export default AdminSaleView;
